import { ToastrService } from 'ngx-toastr';
import { MarcaDispositivoService } from './../../../services/marca-dispositivo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ListaMarcas } from '../../../../../_entities/dispositivos/AgregarDispositivoVM';


@Component({
  selector: 'kt-alta-marca-dispositivo',
  templateUrl: './alta-marca-dispositivo.component.html',
  styleUrls: ['./alta-marca-dispositivo.component.scss']
})
export class AltaMarcaDispositivoComponent implements OnInit {
  public marcaDispositivoForm: FormGroup;
  public param: any;
  public idMarca: any;
  public loading = false;

  constructor(private marcaDispositivoService: MarcaDispositivoService,
    private toastService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.initForm();
    this.param = this.activatedRoute.params.subscribe(
      param => {
        this.idMarca = param["idMarca"];
        if (this.idMarca) {
          this.obtenerMarca(this.idMarca);
        }
      }
    );
  }

  initForm() {
    this.marcaDispositivoForm = this.fb.group({
      Id: [''],
      Nombre: ['']
    });
  }

  obtenerMarca(idMarca: any) {
    this.marcaDispositivoService.obtenerMarca(idMarca).subscribe((res: ListaMarcas) => {
      this.marcaDispositivoForm.setValue({
        Id: res.id,
        Nombre: res.nombre
      });
    }, err => {

    });
  }

  onSubmit() {
    this.loading = true;
    if (this.idMarca) {
      this.marcaDispositivoService.actualizarMarca(this.marcaDispositivoForm.value).subscribe(res => {
        this.toastService.success('Marca actualizada correctamente','Operación exitosa');
        this.router.navigateByUrl('/home/administracion/marca');
      }, err => {
          this.toastService.error('Ocurrio un error al intentar guardar la marca');
          this.router.navigateByUrl('home/administracion/marca');
      },
      () => this.onSubmitComplete());
    } else {
      this.marcaDispositivoService.agregarMarca({nombre: this.marcaDispositivoForm.value.Nombre}).subscribe(res => {
        this.toastService.success('Marca guardada correctamente','Operación exitosa');
        this.router.navigateByUrl('/home/administracion/marca');
      }, err => {
        this.toastService.error('Ourrio un error al registrar la marca');
      },
      () => this.onSubmitComplete());
    }
  }

  onCancel() {
    this.router.navigateByUrl('home/administracion/dispositivos/marca');
  }

  onSubmitComplete() : void {
    this.loading = false;
  }


}
